export default __webpack_public_path__ + "static/media/template4.9d4b0af1.svg";